import axios from "@/index";
const mediaType = {
  state: {
    mediaTypeList: []
  },
  getters: {},
  actions: {
    getMediaTypeList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setMediaTypeList",
                (state, { mediaTypeList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setMediaTypeList(state, action) {
      state.mediaTypeList = action.mediaTypeList;
    }
  }
};
export default mediaType;
